import React, { Component } from "react";
import PointRequiredSection from "./PointRequiredSection";
import { Container, Row } from "react-bootstrap";
import { connect } from "react-redux";
import url from 'url';
import "./DetailRedeem.scss";
import { withRouter } from "react-router-dom";
import { createAction } from "utils";
import PickupStore from 'component/coupon/PickUpStoreSection';
import TicketInfoSection from "component/ticket/TicketInfoSection";
import { CouponSelectionType, CustomerSelectionBehavior } from "utils/CustomEnums";

@connect(({ campaignDetail, store, myCoupon }) => ({ 
  campaignDetail,
  campaignStores: store.campaignStore,
  selectedStore: myCoupon.selectedStore,
  selectedUsageMedium: myCoupon.selectedUsageMedium,
  applicableStoreIsLoading: store.loadingApplicableStores,
}))
class DetailRedeem extends Component {
  constructor(props) {
    super(props);
    const urlSearch = this.props.location.search;
    const query = url.parse(urlSearch, true).query;
    const searchId = query?.campaignID

    this.goBackOnSuccess = this.props.location.state?.goBackOnSuccess || query?.goBackOnSuccess

    this.campaignID = this.props.history.location.state?.campaignID
      || this.props.match.params?.id
      || searchId;

  }
  componentDidMount() {
    this.props.dispatch(
      createAction("campaignDetail/getCampaignDetail")({
        campaignID: this.campaignID,
      })
    );
    this.props.dispatch(
      createAction('store/getCampaignStores')({
        campaignId: this.campaignID,
      }),
    );
  }

  componentWillUnmount() {
  }

  render() {
    const campaign = this.props.location.state?.campaign
      || this.props.campaignDetail?.[this.campaignID]?.data;

    if (campaign?.ticket?.isTicket) {
      return (
        <Container className="detail_container">
          <TicketInfoSection
            isEventActive={campaign?.basic?.isActive}
            detailData={campaign?.ticket}
          />
        </Container>
      )
    }

    const coupon = campaign?.coupon ?? {};
    const stores = this.props.campaignStores;

    const {
      customerStoreSelectionBehavior,
      customerOnlineOfflineSelectionBehavior,
    } = coupon;
    const showStoreSelection = [
      CustomerSelectionBehavior.SELECT_WHEN_ACQUIRE,
      CustomerSelectionBehavior.NO_LIMIT,
    ].includes(customerStoreSelectionBehavior);
    const hasStore = showStoreSelection && stores && stores.length > 0;
    const showMediumSelection = [
      CustomerSelectionBehavior.SELECT_WHEN_ACQUIRE,
      CustomerSelectionBehavior.NO_LIMIT,
    ].includes(customerOnlineOfflineSelectionBehavior);
    let couponSelectionType =null;

    if (showStoreSelection) {
      if (
        customerStoreSelectionBehavior === CustomerSelectionBehavior.NO_LIMIT
      ) {
        couponSelectionType = CouponSelectionType.VIRTUAL_STORE;
      } else {
        couponSelectionType = CouponSelectionType.STORE;
      }
    }
    if (showMediumSelection) {
      if (
        customerOnlineOfflineSelectionBehavior ===
        CustomerSelectionBehavior.NO_LIMIT
      ) {
        couponSelectionType = CouponSelectionType.VIRTUAL_ONLINE_OFFLINE;
      } else {
        couponSelectionType = CouponSelectionType.ONLINE_OFFLINE;
      }
    }
    return (
      <Container className="detail_container">
        {/* <Row className="detail_row">
          <button
            className="back_btn"
            onClick={() => this.props.history.goBack()}
          >
            <img
              alt="go back"
              src="/campaignDetail/backBtn/btn-back.png"
              srcSet="/campaignDetail/backBtn/btn-back@2x.png 2x, /campaignDetail/backBtn/btn-back@3x.png 3x"
            />
          </button>
        </Row> */}
        <Row className="detail_row">
          {hasStore || showMediumSelection ? (
            <PickupStore
              defaultSelectedFirst={true}
              stores={stores}
              applicableStoreIsLoading={this.props.applicableStoreIsLoading}
              couponSelectionType={couponSelectionType}
              isCampaignBuyCoupon={true}
            />
          ) : null}
          <PointRequiredSection
            coupon={coupon}
            campaignID={this.campaignID}
            hasStore={hasStore}
            selectedStore={this.props.selectedStore}
            hasUsageMedium={showMediumSelection}
            selectedUsageMedium={this.props.selectedUsageMedium}
            fromPath={this.props.location.state?.fromPath}
            goBackOnSuccess={this.goBackOnSuccess}
          />
        </Row>
      </Container>
    );
  }
}

export default withRouter(DetailRedeem);
